import { makeStyles } from '@mui/styles';

export const useStyle = makeStyles(() => ({
	root: {
		width: '100%',
		// overflow: 'hidden',
		'& .InfoCard--body': {
			overflow: 'hidden',
		},
	},
}));
